



















import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "LayoutColumnDouble",
  mounted() {
    const mainHeading = this.$refs.mainHeading as HTMLElement;
    if (!mainHeading) return;
    const headingHeight = `${mainHeading.offsetHeight}px`;
    const mainContent = this.$refs.mainContent as HTMLElement;
    mainContent.style.height = `calc(100% - ${headingHeight})`;
  }
});
